// test593
(593 && 0);
